module.exports = __webpack_public_path__ + "img/help28.2655c9af.png";